import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "rounded-xl border-dashed border-2 border-blue-500" }
const _hoisted_2 = {
  class: "text-center",
  style: { marginTop: '-0.75rem' }
}
const _hoisted_3 = { class: "bg-white text-blue-500 font-bold px-2 rounded" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Content = _resolveComponent("Content")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, " このコンテンツは未実装（キー名: " + _toDisplayString(_ctx.keyName || '（未設定）') + "） ", 1)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contents, (content, index) => {
        return (_openBlock(), _createBlock(_component_Content, {
          key: index,
          content: content
        }, null, 8, ["content"]))
      }), 128))
    ])
  ]))
}